import { render, staticRenderFns } from "./TableTdButtonSelectB2B.vue?vue&type=template&id=a12bef8e"
import script from "./TableTdButtonSelectB2B.vue?vue&type=script&lang=js"
export * from "./TableTdButtonSelectB2B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports